export default __webpack_public_path__ + "7a7cc1c7dd79a4796ec584bd49807a55.svg";